import { useState, useEffect } from "react";
import { useAuth } from "./context/AuthProvider";
import { Navigate, Route, Routes, useLocation } from "react-router-dom"; 
import { SocketProvider } from "./context/SocketContext";

// Pages
import Dashboard from "./pages/Dashboard";
import Partenaires from "./pages/partenaires/Partenaires";
import Produits from "./pages/produits/Produits";
import Prospects from "./pages/prospects/prospection/Prospects";
import ProspectDetailPage from "./pages/prospects/prospection/ProspectDetail";
import Leads from "./pages/prospects/leads/Leads";
import Familles from "./pages/prospects/familles/Familles";
import FamilleDetailPage from "./pages/prospects/familles/DetailPage";
import Calendrier from "./pages/calendrier/Calendar";
import Fichiers from "./pages/ftp/Fichiers";
import Documentation from "./pages/documents/Documentation";
import Marketing from "./pages/documents/Marketing";
import Legal from "./pages/documents/Legal";
import Client from "./pages/documents/Client";
import Quantalys from "./pages/tools/Quantalys";
import Impots from "./pages/tools/Impots";
import Brevo from "./pages/tools/Brevo";
import Allocation from "./pages/tools/Allocation";
import Support from "./pages/Support";

// Composants
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Loader from "./components/Loader";
import FlexBetween from "./components/FlexBetween";

// Auth
import ProtectedRoute from "./context/ProtectedRoute"; 
import Login from "./pages/Login";

export default function App() {
  const { user } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <SocketProvider>
      <div className="flex h-screen relative">

        {/* ✅ Sidebar - Fixée à gauche */}
        {user && (
          <div className={`transition-all duration-300 ${isSidebarOpen ? "w-60" : "w-0"} overflow-hidden`}>
            <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
          </div>
        )}

        {/* ✅ Contenu principal + Navbar */}
        <div className="flex flex-col flex-grow bg-white transition-all duration-300"
          style={{
            width: user ? (isSidebarOpen ? "calc(100% - 240px)" : "100%") : "100%",
          }}
        >
          {/* ✅ Navbar sticky en haut */}
          {user && (
            <FlexBetween className="px-4 py-2 bg-white shadow-md top-0 relative z-20">
              <Navbar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
            </FlexBetween>          
          )}

          {/* ✅ Contenu */}
          <main className="flex-grow relative z-10">
            {loading ? (
              <Loader />
            ) : (
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<ProtectedRoute element={<Dashboard />} />} />
                <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
                <Route path="/partenaires" element={<ProtectedRoute element={<Partenaires />} />} />
                <Route path="/produits" element={<ProtectedRoute element={<Produits />} />} />
                <Route path="/prospects/leads" element={<ProtectedRoute element={<Leads />} />} />
                <Route path="/prospects/prospects" element={<ProtectedRoute element={<Prospects />} />} />
                <Route path="/prospects/:id" element={<ProspectDetailPage />} />
                <Route path="/prospects/familles" element={<ProtectedRoute element={<Familles />} />} />
                <Route path="/prospects/familles/:id" element={<ProtectedRoute element={<FamilleDetailPage />} />} />
                <Route path="/calendrier" element={<ProtectedRoute element={<Calendrier />} />} />
                <Route path="/fichiers" element={<ProtectedRoute element={<Fichiers />} />} />
                <Route path="/documents" element={<ProtectedRoute element={<Documentation />} />} />
                <Route path="/documents/marketing" element={<ProtectedRoute element={<Marketing />} />} />
                <Route path="/documents/legal" element={<ProtectedRoute element={<Legal />} />} />
                <Route path="/documents/client" element={<ProtectedRoute element={<Client />} />} />
                <Route path="/outils/quantalys" element={<ProtectedRoute element={<Quantalys />} />} />
                <Route path="/outils/impots" element={<ProtectedRoute element={<Impots />} />} />
                <Route path="/outils/brevo" element={<ProtectedRoute element={<Brevo />} />} />
                <Route path="/outils/allocation" element={<ProtectedRoute element={<Allocation />} />} />
                <Route path="/support" element={<ProtectedRoute element={<Support />} />} />
                <Route path="*" element={<Navigate to={user ? "/dashboard" : "/login"} replace />} />
              </Routes>
            )}
          </main>
        </div>
      </div>
    </SocketProvider>
  );
}
